import React, { useEffect } from "react";
import { Box, Container } from "@mui/material";
import Logo from "../../../assets/logo/1800AccountantLogo.svg";
import ErrorLogo from "../../../assets/icons-svg/error-generic.svg";
import { removeUserType } from "../../../utils/login";

export default function ExpiredLinkError() {

    useEffect(() => {

        removeUserType();
    }, []);

    let companyLogo = localStorage.getItem('companyLogo');
    if (!companyLogo) {
        companyLogo = Logo;
    }
    return (
        <Container maxWidth={false} className="expired-link">
            <div className="expired-link--container">
                <Box>
                    <div className="expired-link--logo">
                        <img src={companyLogo} alt="1800-Accountant logo" />
                    </div>
                    <div className="expired-link--error-logo">
                        <img src={ErrorLogo} alt="Error has occured." />
                    </div>
                    <h2>This link has expired</h2>
                    <p>
                        To receive a new link, contact your payroll
                        administrator.
                    </p>
                </Box>
            </div>
        </Container>
    );
}
